<template>
    <div class="field paragraph" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
            <span v-if="maxLength" class="h6 maxlength text--grey-light">{{ charsRemaining }}</span>
        </div>
        <div class="input">
            <textarea-autosize
                :placeholder="placeholder"
                :value="value"
                :maxlength="maxLength"
                rows="1"
                @input="updated"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: '',
        },
        maxLength: {
            type: Number,
            default: Infinity,
        }
    },

    computed: {
        charsRemaining() {
            return this.maxLength - this.value.length;
        }
    },

    methods: {
        updated(value) {
            this.$emit('input', value);
        }
    }
};
</script>
